<template lang="pug">
div
  transition(name="fade" mode="out-in")
    .transition-wrapper
      .booking-view(v-if="searchAndFilterMode === 'existing' && existingBooking && rentObject && rentObject.rentObjectImages" key="existing")
        .image
          img(:src="rentObject.rentObjectImages[0].thumbnailUrl")
        .content-box.object
          .headline Objektdaten
          .content
            perfect-scrollbar
              div
                b {{rentObject.code}} • {{rentObject.name}}
                div(v-html="rentObject.shortDescription")
                br
                |{{rentObject.metersToBeach}}m zum Strand | {{rentObject.squareMeters}}m² | {{rentObject.persons}} Personen | {{rentObject.rooms}} Zimmer
        .content-box.equipment
          .headline Gastdetails
          .content
            perfect-scrollbar
              table(v-if="existingBooking.customer")
                tbody
                  tr
                    td
                      u Name:
                    td {{existingBooking.customer.title}} {{existingBooking.customer.lastName}}, {{existingBooking.customer.firstName}}
                  tr
                    td
                      u Straße:
                    td {{existingBooking.customer.address.street}}
                  tr
                    td
                      u Ort:
                    td {{existingBooking.customer.address.zip}} {{existingBooking.customer.address.city}}
                  tr
                    td
                      u E-Mail:
                    td {{existingBooking.customer.address.email}}
                  tr
                    td
                      u Mobiltelefon:
                    td {{existingBooking.customer.address.mobile}}
                  tr
                    td
                      u Telefon:
                    td {{existingBooking.customer.address.phone}}
        .content-box.pricelist
          .headline Buchungsdetails
          .content
            perfect-scrollbar
              table(v-if="existingBooking.bookingStatus.uuid !== 'STATUS_BOOKING_BLOCKED'")
                tbody
                  tr
                    td
                      u Bereits gezahlt:
                    td {{payedSum | toCurrency}}
                  tr
                    td
                      u Offener Betrag:
                    td {{leftPayedSum | toCurrency}}
                  tr
                    td
                      u Status:
                    td
                      .status-selection
                        .color-box(:style="{backgroundColor: existingBooking.bookingStatus.colorCode}")
                        |{{existingBooking.bookingStatus.name}}
                  tr
                    td
                      u Zeitraum:
                    td {{formatDate2(existingBooking.startDate)}} - {{formatDate2(existingBooking.endDate)}}
                  tr
                    td
                      u Personen Gesamt:
                    td {{existingBooking.adults+existingBooking.children}}
                  tr
                    td
                      u Erwachsene:
                    td {{existingBooking.adults}}
                  tr
                    td
                      u Kinder:
                    td {{existingBooking.children}}
                  tr
                    td
                      u Anmerkung:
                    td.booking-comment {{existingBooking.comment}}
        .content-box.calculation
          .headline Preisberechnung
          .content
            perfect-scrollbar
              table(v-if="existingBooking.bookingStatus.uuid !== 'STATUS_BOOKING_BLOCKED'")
                tbody
                  tr.total
                    td Gesamtpreis
                    td
                    td
                    td.text-right {{existingBookingCalculation.total/100 | toCurrency}}
                  tr(v-for="row in existingBookingCalculation.items")
                    td {{ row.name }}
                    td {{row.count}}x
                    td.text-right {{row.price/100 | toCurrency}}
                    td.text-right {{row.totalPrice/100 | toCurrency}}
                  tr.avg
                    td Ø ÜN
                    td
                    td
                    td.text-right {{existingBookingCalculation.avgNight/100 | toCurrency}}

      .booking-view(v-else-if="searchAndFilterMode === 'new' && rentObject && rentObject.rentObjectImages" key="booking")
        .image
          img(:src="rentObject.rentObjectImages[0].thumbnailUrl")
        .content-box.object
          .headline Objektdaten
          .content
            perfect-scrollbar
              div
                b {{rentObject.code}} • {{rentObject.name}}
                div(v-html="rentObject.shortDescription")
                br
                |{{rentObject.metersToBeach}}m zum Strand | {{rentObject.squareMeters}}m² | {{rentObject.persons}} Personen | {{rentObject.rooms}} Zimmer
        .content-box.equipment
          .headline Ausstattung
          .content
            perfect-scrollbar
              div
                .feature(v-for="feature in rentObject.rentObjectFeatureTags") {{feature.featureTag.name}}
        .content-box.pricelist
          .headline Preisliste
          .content
            perfect-scrollbar
              div
                .price(v-for="price, idx in rentObject.rentObjectPrices" v-if="dateIsRelevant(idx)")
                  .left
                    .p-name {{price.name}}
                    div {{formatDate(price.startDate)}} - {{rentObject.rentObjectPrices[idx + 1] ? formatDate(rentObject.rentObjectPrices[idx + 1].startDate) : '∞'}}
                  .right
                    div {{price.price/100 | toCurrency}}
        .content-box.calculation
          .headline Preisberechnung | {{formatDate2(newBookingItems.startDate)}} - {{formatDate2(newBookingItems.endDate)}}
          .content
            perfect-scrollbar
              table
                tbody
                  tr.total
                    td Gesamtpreis
                    td
                    td
                    td.text-right {{newBookingItems.total/100 | toCurrency}}
                  tr(v-for="row in newBookingItems.items")
                    td {{ row.name }}
                    td {{row.count}}x
                    td.text-right {{row.price/100 | toCurrency}}
                    td.text-right {{row.totalPrice/100 | toCurrency}}
                  tr.avg
                    td Ø ÜN
                    td
                    td
                    td.text-right {{newBookingItems.avgNight/100 | toCurrency}}  

      .filter-wrapper(v-show="searchAndFilterMode !== 'new' && searchAndFilterMode !== 'existing'" key="filter")
        .search.one
          b-field(grouped expanded)
            b-field(label="Anreise" label-position="on-border" expanded)
              v-date-picker(:columns="2" v-model="selectedDateRange.startDate" :popover="popoverConfig" ref="startDate" :input-debounce="999999" @input="() => checkStartDate('picked')" :attributes="[{dates: new Date(), highlight: { fillMode: 'outline' }}]")
                template(#default='{ inputValue, inputEvents }')
                  input.input(:value='inputValue' v-on='inputEvents' ref="startDateInput" @input="checkStartDate")

            b-field.small-width(label="ÜN" label-position="on-border")
              b-input(numeric :value="dateRangeDays" @input="updateDateRange")

            b-field(label="Abreise" label-position="on-border" expanded)
              v-date-picker(:columns="2" v-model="selectedDateRange.endDate" :popover="popoverConfig" ref="endDate" :input-debounce="999999" @input="() => checkEndDate('picked')")
                template(v-slot='{ inputValue, inputEvents }')
                  input.input(:value='inputValue' v-on='inputEvents' ref="endDateInput" @input="checkEndDate" :tabindex="dateRangeDays && selectedDateRange.endDate ? '-1' : '0'")

          b-field(grouped)
            b-field(label="Personen" label-position="on-border" expanded)
              b-select(expanded @input="$root.$emit('objectPersonsSearchString', $event)")
                option(:value="null")
                option(v-for="i in searchResults.maxPersons" :value="i") {{i}}
            b-field(label="Zimmeranzahl" label-position="on-border" expanded)
              b-select(expanded @input="$root.$emit('objectRoomsSearchString', $event)")
                option(:value="null")
                option(v-for="i in searchResults.maxRooms" :value="i") {{i}}

          b-field(label="Objektname" label-position="on-border")
            b-input(value="" @input="$root.$emit('objectNameSearchString', $event)")
        .search.two
          b-field(label="Zu Datum springen" label-position="on-border")
            v-date-picker(:columns="4" v-model="jumpToDate" :popover="popoverConfig" ref="selectDate" @input="() => checkSelectDate('picked')")
              template(v-slot='{ inputValue, inputEvents }')
                input.input(:value='inputValue' v-on='inputEvents' ref="selectDateInput" @input="checkSelectDate")
          b-field(label="Gastname" label-position="on-border")
            b-autocomplete(
              @input="(e) => searchGuests(e)"
              placeholder="z.B. Musterfrau, Tina"
              :keep-first="true"
              :open-on-focus="false"
              :data="guestNameResults"
              field="complete"
              @select="option => highlightBooking(option)"
              :clearable="true"
            )
              template(slot-scope="props")
                .guest-autocomplete-row
                  .color-box(:style="{backgroundColor: props.option.colorCode}")
                  .name {{props.option.complete}}

          b-field(grouped)
            b-field(label="Vertragsnr." label-position="on-border" expanded)
              b-autocomplete(
                @input="(e) => searchContracts(e)"
                placeholder=""
                :keep-first="true"
                :open-on-focus="false"
                :data="contractResults"
                field="id"
                @select="option => highlightBooking(option ? option.rentObjectBooking : null)"
                :clearable="true"
              )
            b-field(label="Angebotsnr." label-position="on-border" expanded)
              b-autocomplete(
                @input="(e) => searchOffers(e)"
                placeholder=""
                :keep-first="true"
                :open-on-focus="false"
                :data="offerResults"
                field="id"
                @select="option => highlightBooking(option ? option.rentObjectBooking : null)"
                :clearable="true"
              )
              
        .search.three
          .status-selection-wrapper
            .status-selection(v-for="status in statusList"
                              :class="{inactive: !status.isActive}"
                              @click="status.isActive = !status.isActive"
                              v-show="status.isVisible")
              .color-box(:style="{backgroundColor: status.colorCode}")
                svg.tick(v-if="status.isActive" xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='3' stroke-linecap='round' stroke-linejoin='round')
                  polyline(points='20 6 9 17 4 12')
              |{{status.name}}
          .filter-selection-wrapper
            .filter-selection-box(v-for="boxNr in Math.ceil(searchResults.featureTags.length / 3)")
              .filter-selection(v-for="tag in searchResults.featureTags.slice((boxNr-1)*3, boxNr*3)" v-if="tag.showAdmin" :style="{opacity: tag.count === 0 ? 0.4 : 1}")
                input(:value="tag.active" @input="toggleTag(tag)" type="checkbox" :checked="false" :id="tag.name.replace(' ', '-').toLowerCase()" :disabled="tag.count === 0")
                label(:for="tag.name.replace(' ', '-').toLowerCase()") {{tag.name}}
                label.count(:for="tag.name.replace(' ', '-').toLowerCase()") {{tag.count}}
</template>

<script>
import { DateTime } from "luxon";

export default {
  data() {
    return {
      // Filter Stuff
      guestNameSearchString: "",
      guestNameResults: [],
      selectedGuestName: null,
      showSearchedGuestBookings: false,

      contractSearchString: "",
      contractResults: [],
      offerSearchString: "",
      offerResults: [],

      // Core Stuff
      searchResults: {
        featureTags: []
      },
      jumpToDate: new Date(),
      selectedDateRange: {
        startDate: null,
        endDate: null,
        days: 1
      },
      dateRangeDays: null,
      searchData: {
        startDate: null,
        endDate: null,
        persons: null,
        bedrooms: null,
        rentObjectId: null,
        customerId: null,
        offerId: 'to do :)',
        contractId: 'to do :)',
        activeFeatures: []
      },
      statusList: [],
      popoverConfig: {
        visibility: 'focus',
        showDelay: 0,
        hideDelay: 1,
      }
    };
  },
  computed: {
    newBookingItems() {
      if (!this.newBookingCalculation) {
        return {items: [], total: 0, avgNight: 0};
      }

      const items = [];
      let total = 0;
      let nightTotal = 0;
      let nightCount = 0; 
      for (let i = 0; i < this.newBookingCalculation.priceItems.length; i += 1) {
        total += this.newBookingCalculation.priceItems[i].totalPrice;
        nightTotal += this.newBookingCalculation.priceItems[i].totalPrice;
        nightCount += this.newBookingCalculation.priceItems[i].count;
        items.push(this.newBookingCalculation.priceItems[i]);
      }
      for (let i = 0; i < this.newBookingCalculation.bookingExtraItems.length; i += 1) {
        if (this.newBookingCalculation.bookingExtraItems[i].isMandatory) {
          total += this.newBookingCalculation.bookingExtraItems[i].totalPrice;
          items.push(this.newBookingCalculation.bookingExtraItems[i]);
        }
      }
      return {items, total, avgNight: nightTotal/nightCount, startDate: this.newBookingCalculation.startDate, endDate: this.newBookingCalculation.endDate};
    },
    existingBookingCalculation() {
      if (!this.existingBooking) {
        return {items: [], total: 0, avgNight: 0};
      }

      const items = [];
      let total = 0;
      let nightTotal = 0;
      let nightCount = 0;
      const priceItems = this.existingBooking.bookingItems.filter(e => ['rentObjectPrices', 'promotions', 'discount'].includes(e.referenceColumnName));
      const bookingExtraItems = this.existingBooking.bookingItems.filter(e => e.referenceColumnName === 'rentObjectBookingExtras');
      for (let i = 0; i < priceItems.length; i += 1) {
        total += priceItems[i].totalPrice;
        nightTotal += priceItems[i].totalPrice;
        nightCount += priceItems[i].count;
        items.push(priceItems[i]);
      }
      for (let i = 0; i < bookingExtraItems.length; i += 1) {
        total += bookingExtraItems[i].totalPrice;
        items.push(bookingExtraItems[i]);
      }
      return {items, total, avgNight: nightTotal/nightCount};
    },
    searchAndFilterMode() {
      return this.$store.state.rentObjectBookings.searchAndFilterMode;
    },
    newBookingCalculation() {
      return this.$store.state.rentObjectBookings.newBookingCalculation;
    },
    existingBooking() {
      return this.$store.state.rentObjectBookings.single;
    },
    payedSum() {
      let totalPayed = 0;
      if (!this.existingBooking) return totalPayed;

      for (let i = 0; i < this.existingBooking.payments.length; i += 1) {
        totalPayed += this.existingBooking.payments[i].total;
      }
      return totalPayed/100;
    },
    leftPayedSum() {
      let totalPayed = 0;
      let total = 0;
      if (!this.existingBooking) return totalPayed;
      for (let i = 0; i < this.existingBooking.bookingItems.length; i += 1) {
        total += this.existingBooking.bookingItems[i].totalPrice;
      }
      if (!this.existingBooking.parentContract) return total/100;

      for (let i = 0; i < this.existingBooking.payments.length; i += 1) {
        totalPayed += this.existingBooking.payments[i].total;
      }
      let leftPayment = this.existingBooking.parentContract.contracts[this.existingBooking.parentContract.contracts.length-1].totalPrice - totalPayed;
      if (this.existingBooking.bookingStatus.uuid === 'STATUS_BOOKING_CANCELED_FINAL') {
        leftPayment = this.existingBooking.cancelInvoices[this.existingBooking.cancelInvoices.length-1].totalPrice - totalPayed;
      }
      return leftPayment/100;
    },
    rentObject() {
      return this.$store.state.rentObjects.single;
    },
    featureTags() {
      return this.$store.state.featureTags.all.filter(f => f.showAdmin)
    },
    searchString() {
      let queries = '?'

      if (this.searchData.startDate) {
        queries += '&start=' + DateTime.fromJSDate(this.searchData.startDate).toHTTP()
      }
      if (this.searchData.endDate) {
        queries += '&end=' + DateTime.fromJSDate(this.searchData.endDate).toHTTP()
      }
      if (this.searchData.persons) {
        queries += '&persons=' + this.searchData.persons
      }
      if (this.searchData.rooms) {
        queries += '&rooms=' + this.searchData.rooms
      }

      let featureQuery = '&features='
      for (let i = 0; i < this.searchData.activeFeatures.length; i += 1) {
          featureQuery += this.searchData.activeFeatures[i].id + ','
      }

      if (featureQuery.length > 11) { // because the string '&features=' has length 10
        queries += featureQuery
        queries = queries.substring(0, queries.length - 1)
      }

      if (queries.length > 2) {
        queries = queries.slice(0, 1) + queries.slice(2)
      }

      return queries
    }
  },
  watch: {
    searchString() {
      this.getSearchResults();
    },
    statusList: {
      deep: true,
      handler(newVal, oldVal) {
        if (oldVal.length === 0) return;
        this.getSearchResults('onlyFilterStatus');
      }
    }
  },
  created() {
    this.$root.$on('reloadCalendar', () => {
      this.getSearchResults();
    });
    this.$root.$on('setNewTimeframe', (timeframe) => {
      this.searchData.startDate = timeframe.startDate;
      this.searchData.endDate = timeframe.endDate;
    });
  },
  async mounted() {
    this.statusList = await this.$store.dispatch("bookingStatus/findAll"); // here we load the search results already - so do not wonder
    await this.$store.dispatch("featureTags/findAll");
    this.searchData.features = JSON.parse(JSON.stringify(this.$store.state.featureTags.all.filter(f => f.showAdmin)));
  },
  methods: {
    checkStartDate(mode) {
      this.statusList.find(s => s.uuid === "STATUS_BOOKING_OFFER").isActive = false; // When you search for a contract the offer status gets DE!activated automatically
      
      if (mode === 'picked') {
        this.completeDateRange();
      }

      const d = this.checkIfDateTransformationIsPossible(this.$refs.startDateInput.value);
      if (d) {
        this.$refs.startDate.hidePopover();
        this.$nextTick(()=> {
          this.$refs.startDateInput.value = d;
          this.selectedDateRange.startDate = d;
          this.completeDateRange();
        });
      }
    },
    checkEndDate(mode) {
      if (mode === 'picked') {
        this.completeDateRange();
      }

      let d = this.checkIfDateTransformationIsPossible(this.$refs.endDateInput.value);

      // It can be that the end date is one year smaller than the start date due to the quick input magic
      // Here we check and  adjust
      if (d && d.getFullYear() < this.selectedDateRange.startDate.getFullYear()) {
        d.setFullYear(d.getFullYear() + 1);
      }

      if (d) {
        this.$refs.endDate.hidePopover();
        this.$nextTick(()=> {
          this.$refs.endDateInput.value = d;
          this.selectedDateRange.endDate = d;
          this.completeDateRange();
        });
      }
    },
    checkSelectDate(mode) {
      if (mode === 'picked') {
        this.$emit("jumpToDate", this.jumpToDate);
      }

      const d = this.checkIfDateTransformationIsPossible(this.$refs.selectDateInput.value);
      if (d) {
        this.jumpToDate = d;
        this.$refs.selectDateInput.value = d;
        this.$refs.selectDate.hidePopover();
        this.$emit("jumpToDate", this.jumpToDate);
      }
    },
    checkIfDateTransformationIsPossible(val) {
      if (val.length === 4 && val.includes('.') === false) {
        const day = parseInt(val.substring(0, 2));
        const month = parseInt(val.substring(2, 4));
        if (day <= 0 || day > 31) return null;
        if (month <= 0 || month > 12) return null;
        const today = DateTime.local();
        const isSmaller = month < today.month || (month == today.month && day < today.day);
        const dt = DateTime.fromObject({
          day,
          month,
          year: isSmaller ? today.year + 1 : today.year
        })
        return dt.toJSDate();
      }
    },
    completeDateRange() {
      if (this.selectedDateRange.startDate instanceof Date && this.selectedDateRange.endDate instanceof Date) {
        if (this.selectedDateRange.startDate >= this.selectedDateRange.endDate) {
          this.selectedDateRange.endDate = null;
          this.$refs.endDateInput.value = null;
          this.selectedDateRange.days = 0;
          this.dateRangeDays = null;
          return
        }
        const start = DateTime.fromJSDate(this.selectedDateRange.startDate);
        const end = DateTime.fromJSDate(this.selectedDateRange.endDate);
        this.dateRangeDays = Math.ceil(end.diff(start, 'days').toObject().days);
        this.$emit("selectDateRange", this.selectedDateRange);
      }
    },
    dateIsRelevant(idx) {
      if (!this.rentObject.rentObjectPrices[idx + 1]) return true;
      
      if (new Date(this.rentObject.rentObjectPrices[idx].startDate) < new Date() && new Date(this.rentObject.rentObjectPrices[idx + 1].startDate) < new Date()) return false;
      
      return true
    },
    formatDate3(dt) {
      if (!dt) return '';
      if (dt instanceof Date) {
        dt = DateTime.fromJSDate(dt);
      }
      return dt.setLocale('de')
        .toFormat("dd.LL.yyyy")
    },
    formatDate2(d) {
      const dt = DateTime.fromISO(d);
      return dt.setLocale('de')
        .toFormat("dd.LL.yyyy")
    },
    formatDate(d) {
      const dt = DateTime.fromISO(d);
      return dt.setLocale('de')
        .toFormat("dd. LLL. yy")
    },
    toggleTag(tag) {
      for (let i = 0; i < this.searchData.activeFeatures.length; i += 1) {
        if (this.searchData.activeFeatures[i].id === tag.id) {
          this.searchData.activeFeatures.splice(i, 1);
          return
        }
      }
      this.searchData.activeFeatures.push(tag);
    },
    async getSearchResults(onlyFilterStatus) {

      this.$root.$emit('startLoadingBookingData');

      if (!onlyFilterStatus) {
        const searchResults = await this.$store.dispatch("rentObjects/search", this.searchString);
        this.searchResults = searchResults;

        for (let i = 0; i < searchResults.featureTags.length; i += 1) {
          const existingFeature = this.searchData.activeFeatures.find(f => f.id === searchResults.featureTags[i].id)
          searchResults.featureTags[i].active = existingFeature ? existingFeature.active : false
        }
      }

      // When onlyFilterStatus is true, we only filter the status and don't fetch new data
      // Much better UX and performance
      const rentObjects = JSON.parse(JSON.stringify(this.searchResults.searchResults));
      for (let i = 0; i < rentObjects.length; i += 1) {
        for (let b = 0; b < rentObjects[i].rentObjectBookings.length; b += 1) {
          const filteredBookings = rentObjects[i].rentObjectBookings.filter((b)=>{
            const status = this.statusList.find(s => s.id === b.bookingStatusId);
            if (!status) alert("Etwas ist schief gegangen mit dem Statusfilter. Versuchen Sie es erneut.")
            if (this.$route.query.bookingStatusId && b.bookingStatusId.toString() === this.$route.query.bookingStatusId.toString()) {
              status.isActive = true;
              this.$route.query.bookingStatusId = undefined;
            }
            return status.isActive
          });
          rentObjects[i].rentObjectBookings = filteredBookings;
        }
      }
      this.$emit("searchResults", rentObjects);
      this.$root.$emit('stopLoadingBookingData');
    },
    updateDateRange(e) {
      if (e === '' || e === null || e.value === 0 || e === undefined || e.value === '0') {
        return
      }

      if (this.selectedDateRange.startDate) {
        const start = DateTime.fromJSDate(this.selectedDateRange.startDate);
        this.selectedDateRange.endDate = start.plus({days: e}).toJSDate();
        this.selectedDateRange.days = e;
        this.dateRangeDays = e;
        this.$emit("selectDateRange", this.selectedDateRange);
      } else if (this.selectedDateRange.endDate) {
        const end = DateTime.fromJSDate(this.selectedDateRange.endDate);
        this.selectedDateRange.startDate = end.minus({days: e}).toJSDate();
        this.selectedDateRange.days = e;
        this.dateRangeDays = e;
        this.$emit("selectDateRange", this.selectedDateRange);
      }
    },
    async searchGuests(searchString) {
      const bookings = await this.$store.dispatch("rentObjectBookings/search", {searchString: searchString});
      this.guestNameResults = bookings.map(b => {
        let lastId = null;
        if (b.bookingStatus.uuid === 'STATUS_CONTRACT_SENT' || b.bookingStatus.uuid === 'STATUS_CONTRACT_RECEIVED') {
          lastId = b.parentContractId;
        }
        if (b.bookingStatus.uuid === 'STATUS_BOOKING_CANCELED_FINAL') {
          lastId = b.cancelInvoices[b.cancelInvoices.length - 1].id;
        }
        if (b.bookingStatus.uuid === 'STATUS_BOOKING_OFFER') {
          lastId = b.offers[b.offers.length - 1].id;
        }
        return {...b, colorCode: b.bookingStatus.colorCode, complete: `${lastId ? '#'+lastId+' ' : ''}${b.customer && b.customer.lastName ? b.customer.lastName : '-'}${b.customer && b.customer.firstName ? ', ' + b.customer.firstName : '-'}`}
      });
    },
    async searchContracts(searchString) {
      this.statusList.find(s => s.uuid === "STATUS_BOOKING_OFFER").isActive = false; // When you search for a contract the offer status gets DE!activated automatically
      // Changed from 'contracts' to 'parent-contracts' -> 18.Jan 2021
      const contracts = await this.$store.dispatch("parentContracts/search", {searchString: searchString});
      if (contracts[0]) {
        this.highlightBooking(contracts[0].rentObjectBooking);
      }
      this.contractResults = contracts;
    },
    async searchOffers(searchString) {
      this.statusList.find(s => s.uuid === "STATUS_BOOKING_OFFER").isActive = true; // When you search for an offer the status gets activated automatically
      const offers = await this.$store.dispatch("offers/search", {searchString: searchString});
      if (offers[0]) {
        this.highlightBooking(offers[0].rentObjectBooking);
      }
      this.offerResults = offers;
    },
    highlightBooking(rentObjectBooking) {
      if (rentObjectBooking && rentObjectBooking.startDate && rentObjectBooking.endDate) {
        // We reset the rentObject filtering first
        this.$root.$emit('objectNameSearchString', '');

        // Then we jump to the booking
        this.$root.$emit('jumpToBooking', {
          startDate: new Date(rentObjectBooking.startDate),
          endDate: new Date(rentObjectBooking.endDate),
          rentObjectId: rentObjectBooking.rentObjectId
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.filter-wrapper {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  padding: $sm-space;
  background-color: white;
  border-right: solid 1px lightgray;
  display: grid;
  grid-template-areas: "one two three";
  grid-template-columns: 280px 240px auto;
  column-gap: $sm-space;
}

.search {
  &.one {
    grid-area: one;
  }
  &.two {
    grid-area: two;
  }
  &.three {
    grid-area: three;
    display: grid;
    grid-auto-rows: auto auto;
  }
}

.field.is-grouped {
  height: 38px;
}

.guest-autocomplete-row {
  display: flex;
  justify-content: flex-start;
}

.color-box {
  position: relative;
  height: 16px;
  min-width: 24px;
  max-width: 24px;
  border-radius: 99px;
  // border: solid 1px black;
  display: inline-block;
  margin-right: 3px;
}

.status-selection-wrapper {
  .status-selection {
    // font-family: Arial,sans-serif;
    // width: calc(20% - 4px);
    display: inline-block;
    padding: 2px 4px;
    font-size: 14px;
    margin-right: 4px;
    margin-bottom: 4px;
    font-weight: 500;
    cursor: pointer;
    user-select: none;
    text-align: left;
    color: black !important;
    .color-box {
      position: relative;
      height: 16px;
      width: 24px;
      border-radius: 99px;
      // border: solid 1px black;
      display: inline-block;
      margin-right: 3px;
      .tick {
        position: absolute;
        top: 36%;
        left: 64%;
        transform: translate(-50%, -50%);
      }
    }
    &:hover {
      background-color: $light;
    }
  }
}

.filter-selection-wrapper {
  display: flex;
  justify-content: flex-start;
  overflow-y: auto;
  border: solid 1px $lightgray;
  .filter-selection-box {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .filter-selection {
    // font-family: Arial,sans-serif;
    white-space: nowrap;
    width: calc(20% - 8px);
    display: inline-block;
    padding: 2px 4px;
    font-size: 14px;
    line-height: 14px;
    margin-right: 4px;
    font-weight: 500;
    cursor: pointer;
    user-select: none;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    input {
      margin-right: 4px;
    }
    label {
      cursor: pointer;
      &.count {
        margin-left: 2px;
        font-size: 9px;
        height: 12px;
        width: 12px;
        line-height: 12px;
        color: $darkgray;
      }
    }
  }
}

.transition-wrapper {
  height: 100%;
}

.booking-view {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  display: grid;
  grid-template-areas: "image object equipment pricelist calculation";
  grid-template-columns: 256px auto 400px 400px 400px;
  grid-template-rows: 100%;
  font-size: 14px;
  .image {
    grid-area: image;
    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
  }
  .object {
    grid-area: object;
  }
  .equipment {
    grid-area: equipment;
  }
  .pricelist {
    grid-area: pricelist;
  }
  .calculation {
    grid-area: calculation;
    table {
      font-size: 14px;
      
        tr.total {
          font-weight: 500;
          background-color: $primary;
          color: white;
        }
        tr.avg {
          font-style: italic;
          color: $darkgray;
        }
      
      td {
        padding: 0em 0.75em;
      }
    }
  }
}
.content-box {
  border: solid 1px darken($light, 4%);
  background-color: white;
  border-radius: 4px;
  margin-left: $sm-space;
  max-height: 100%;
  .headline {
    font-weight: 500;
    font-size: 14px;
    background-color: $light;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    height: 26px;
  }
  .content {
    padding: $xs-space;
    // max-height: calc(100% - 16px);
    overflow: hidden;
    .ps {
      height: 140px;
    }
    .feature {
      // border-bottom: solid 1px $lightgray;
      padding: 2px 0;
      .bolder {
        margin-left: 8px;
        display: inline-block;
        font-weight: 500;
      }
    }
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.price {
  display: flex;
  justify-content: center;
  font-size: 14px;
  .left, .right {
    width: 50%;
    border-bottom: solid 1px $lightgray;
  }
  .p-name {
    font-weight: 500;
  }
  .right {
    border-left: solid 1px $lightgray;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.text-right {
  text-align: right;
}

.small-width {
  width: 48px;
}

table {
  .status-selection {
    // font-family: Arial,sans-serif;
    // width: calc(20% - 4px);
    display: inline-block;
    font-size: 14px;
    margin-right: 4px;
    font-weight: 500;
    user-select: none;
    text-align: left;
    color: black !important;
    .color-box {
      height: 16px;
      width: 24px;
      border-radius: 99px;
      display: inline-block;
      margin-right: 3px;
    }
  }
}
.booking-comment {
  white-space: pre-line;
}
</style>
